<div class="footer">
  <div class="container">
    <div class="pull-left">
      <span tabindex="-1">&copy; <script> var d = new Date();document.write(d.getFullYear());</script> Press Ganey Associates LLC</span>
      <span tabindex="-1" class="break"></span>
      <span tabindex="-1">Telephone : 855.304.9788 </span>
      <span tabindex="-1" class="break"></span>
      <span tabindex="-1"><a href="mailto:NDNQISupport@pressganey.com" tabindex="-1">NDNQISupport&#64;pressganey.com</a></span>
      <span tabindex="-1" class="break"></span>
      <span tabindex="-1">Version : {{applicationVersion}} </span>
      <!-- <span tabindex="-1" class="break" *ngIf="swAppVersion"></span>
      <span tabindex="-1" *ngIf="swAppVersion">swVersion : {{swAppVersion}} </span> -->
      @if (timeoutCounterDisplayEnabled) {
        <ng-container>
          <span tabindex="-1" class="break"></span>
          <span tabindex="-1">Timeout : {{timeoutRemaining}} </span>
        </ng-container>
      }
    </div>
    <div class="pull-right">

    </div>
  </div>
</div>
